import { Text, Box, Button } from '@chakra-ui/react';
import { DashboardSection } from '../../components/DashboardStyles';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function CreateStore() {
    const navigate = useNavigate();
    const store = useSelector((state) => state.storeReducer.store);
    return (
        <DashboardSection>
            <Box
                maxWidth={{
                    base: '100%',
                    sm: '80%',
                    md: '60%',
                    lg: '60%',
                    xl: '80%',
                }}
                display="flex"
                flexDirection="column"
                gap="2rem">
                <Text
                    width="100%"
                    fontWeight="400"
                    fontSize={{
                        base: '0.875rem',
                        sm: '1rem',
                        md: '1.2rem',
                        lg: '1.225rem',
                        xl: '1.25rem',
                    }}>
                    Hello {store?.name} - You have not added any products to your store
                </Text>
                <Box
                    display="flex"
                    flexDirection={{
                        base: 'column',
                        sm: 'column',
                        md: 'row',
                        lg: 'row',
                    }}
                    gap="1rem">
                    <Button
                        fontSize="xs"
                        background="#1b3b5f"
                        color="#ffffff"
                        onClick={() => navigate('/dashboard/store/products/create-product')}
                        _hover={{
                            background: 'none',
                            color: '#1b3b5f',
                            border: '1px solid #1b3b5f',
                        }}>
                        Add Product
                    </Button>
                    <Button
                        fontSize="xs"
                        color="#1b3b5f"
                        background="#ffffff"
                        border="1px solid #1b3b5f"
                        onClick={(e) => navigate('/dashboard/products')}
                        _hover={{
                            background: '#1b3b5f',
                            color: '#ffffff',
                            border: '1px solid #ffffff',
                        }}>
                        Buy Products from Obana
                    </Button>
                </Box>
            </Box>
        </DashboardSection>
    );
}
